module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iNyIgd2lkdGg9IjgiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMxRDFEMUQiLz4KPHJlY3QgeD0iOSIgeT0iNCIgd2lkdGg9IjgiIGhlaWdodD0iMiIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDkgNCkiIGZpbGw9IiMxRDFEMUQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon_collapse_on.svg
// module id = mbE9
// module chunks = 1